function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVimeo = function SvgVimeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M432.3 165c-1.6 35.6-26.4 84.3-74.4 146.2-49.6 64.6-91.6 96.9-126 96.9-21.3 0-39.3-19.7-54-59-9.8-36.1-19.6-72.2-29.5-108.2-10.9-39.3-22.6-59-35.2-59-2.7 0-12.3 5.8-28.6 17.2l-17.2-22.2c18-15.9 35.8-31.7 53.3-47.6 24-20.8 42.1-31.7 54.1-32.8 28.4-2.7 45.9 16.7 52.5 58.4 7.1 44.9 12 72.9 14.8 83.8 8.2 37.3 17.2 55.9 27 55.9 7.6 0 19.1-12.1 34.4-36.3 15.3-24.2 23.5-42.6 24.6-55.2 2.2-20.9-6-31.3-24.6-31.3-8.7 0-17.7 2-27 6 17.9-58.9 52.2-87.5 102.8-85.8 37.5 1 55.2 25.4 53 73",
    style: {
      fill: "#32b8e8"
    }
  }));
};

export default SvgVimeo;